export default __webpack_public_path__ + "static/technology-50739f69d4eab0225550a6f48f0337ec.png";